import * as _ from "lodash"
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {EventVolumeBO} from "./EventVolumeBO";

export class EventVolumeBOValidations {

    static async ValidateFields(aBO: EventVolumeBO): Promise<void> {

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_EvtVolume.cif.CONTROL_POINT_ID),
            "emptyID", "Control Point Id cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_EvtVolume.cif.CONTROL_POINT_NAME),
            "emptyName", "Control Point Name cannot be empty")
    }
}